import React, { useState } from 'react';
import { OrganizationChart } from 'primereact/organizationchart';

import './style.css';

const Organograma = (props) => {
    const [isSelection, setSelection] = useState(false);
    const { dadosHierarquia } = props;

    const nodeTemplate = (node) => {
        if (node.type === 'person') {
            return (
                <div>
                    <div className="node-header">{node.label}</div>
                    <div className="node-content">
                        <div>{node.dataNome.nome} </div>
                    </div>
                </div>
            );
        }

        if (node.type === 'department') {
             let data = <div>{node.dataNome.nome} </div>
            return data;
        }
    };

    return (
        <div className="organizationchart-demo">
            <div className="card">
                {dadosHierarquia && (
                    <OrganizationChart
                        value={dadosHierarquia}
                        nodeTemplate={nodeTemplate}
                        selection={isSelection}
                        selectionMode="single"
                        onSelectionChange={(event) => {
                            setSelection(event.data);
                        }}
                        className="company"
                    />
                )}
            </div>
        </div>
    );
};

export default Organograma;